import Header from "./Header";
import Footer from "./Footer";
import LoadingPage from "../general/LoadingPage";
import {ID_TOKEN} from "../../conf";
import {useEffect} from "react";
import {decodeIdToken, useFindById} from "../../services/session/apiSession";
import Cookies from "js-cookie";
import {useSessionStore} from "../../services/storage/session/SessionStorage";

interface Props {
    children?: React.ReactNode;
}

export function Layout({children}: Props){
    const {mutate: findUser, isPending: loading, data: successFindUser} = useFindById();
    const setUser = useSessionStore(data => data.setUser)

    useEffect(() => {
        const user = decodeIdToken(Cookies.get(ID_TOKEN))
        if (user && user?.preferred_username) {
            findUser({username: user?.preferred_username.toUpperCase()})
        }
    }, []);

    useEffect(() => {
        if (successFindUser) {
            setUser(successFindUser);
        }
    }, [successFindUser]);

    return (
        <>
            <div className={"h-screen flex flex-col bg-fondo"}>
                {
                    loading ?
                        <LoadingPage className={'bg-header min-h-[100vh]'} logo={true}/> :
                        <>
                            <Header/>
                            <div className={`custom-container-all-window mt-[120px] px-2 sm:px-0 sm:mt-[87px]`}>
                                <div className={`center-column h-screen sm:h-full`}>
                                    <div className={'pb-3 body'}>
                                        <main>{children}</main>
                                    </div>
                                    <Footer/>
                                </div>
                            </div>
                        </>
                }
            </div>
        </>
    );
}
